export default __webpack_public_path__ + "static/media/DeleteIcon.0374466d.png";